import { render, staticRenderFns } from "./XhCustomerAddress.vue?vue&type=template&id=8bcdc1a6&scoped=true"
import script from "./XhCustomerAddress.vue?vue&type=script&lang=js"
export * from "./XhCustomerAddress.vue?vue&type=script&lang=js"
import style0 from "./XhCustomerAddress.vue?vue&type=style&index=0&id=8bcdc1a6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcdc1a6",
  null
  
)

export default component.exports